import styled from '@emotion/styled';
import React, { useEffect } from 'react';

export const IROLL_IFRAME_ID = 'iroll-iframe';

export enum IrollEvent {
  READY = 'iroll-ready',
  ENDED = 'iroll-ended',
  VIDEO_PROGRESS = 'iroll-video-progress',
  REQUEST_START = 'request-start-playback',
  REQUEST_PAUSE = 'iroll-request-playback-pause'
}

export const createIrollKeyEvent = ({ key, type, keyCode }) =>
//@ts-ignore
  new KeyboardEvent(type, { key, keyCode, bubbles: true });

let irollMuted = false;

export const toggleIrollMute = () => {
  const iframe = document.getElementById(IROLL_IFRAME_ID);
  // @ts-ignore
  const video = iframe.contentWindow.document.getElementsByTagName('video')[0];
  irollMuted = !irollMuted;
  if (!!video) {
    //@ts-ignore
    video.muted = irollMuted;
  }
};

export const CtvIroll = ({ previewUrl, irollEventMap }) => {

  const toggleIframeHide = (hide) =>
    //@ts-ignore
    document.getElementById(IROLL_IFRAME_ID).style.visibility = (hide)
      ? 'hidden'
      : 'visible';

  useEffect(() => {
    //@ts-ignore
    const restartCtvIroll = () => document.getElementById(IROLL_IFRAME_ID).src = previewUrl;

    const validateBodyFocus = () => {
      if (document.activeElement?.tagName !== 'BODY') {
        //@ts-ignore
        document.body.focus();
        //@ts-ignore
        document.activeElement.blur();
      }
    };

    const sendEventToCypress = (evt) => {
        //@ts-ignore
      if (!!window.Cypress && !!window.top?.Runner) {
          window.top?.postMessage(evt.data, '*');
        }
    };

    const irollEventsListener = (evt) => {
      const irollEvent = evt.data?.type;
      validateBodyFocus();
      sendEventToCypress(evt);
      if (irollEvent === IrollEvent.ENDED) {
        toggleIframeHide(true);
        restartCtvIroll();
      } else if (irollEvent === IrollEvent.READY) {
        toggleIframeHide(false);
      }
      irollEventMap[irollEvent] && irollEventMap[irollEvent]();
    };

    const KeyEventListener = (evt) => {
      //@ts-ignore
      let frame = document.getElementById(IROLL_IFRAME_ID)?.contentDocument;
      frame?.dispatchEvent(createIrollKeyEvent(evt));
    };

    window.addEventListener('keydown', KeyEventListener);
    window.addEventListener('keyup', KeyEventListener);
    window.addEventListener('message', irollEventsListener);
    toggleIframeHide(true);
    return () => {
      window.removeEventListener('message', irollEventsListener);
      window.removeEventListener('keyup', irollEventsListener);
      window.removeEventListener('keydown', irollEventsListener);
    };
    // eslint-disable-next-line
  }, [previewUrl]);

  const sendIrollRequest = (irollRequest: IrollEvent) => {
    const iframe = document.getElementById(IROLL_IFRAME_ID);
    if (!!iframe) {
      //@ts-ignore
      iframe?.contentWindow?.postMessage({ type: irollRequest },
        '*');

    }
  };

  const irollIframe = <TvIframe id={IROLL_IFRAME_ID} src={previewUrl}/>;

  return { irollIframe, sendIrollRequest };
};

const TvIframe = styled.iframe`
    position: relative;
    width: 99.5%;
    height: 88%;
    border: none;
    top: 1.2%;
`;
